import { WidgetBase } from '../../../_common/platform/ts/WidgetBase';
import { init as mainTheme } from './themes/main';
import { HTMLContainerWidget as mainModule } from './main';
import * as $ from 'jquery';

declare var require: any;
require('../sass-main/pdc-widget-html.sass');
const FieldModulesLoader = require('_common/platform/jsx/mixins/FieldModulesLoader');

FieldModulesLoader.addModules({
    'pdc-widget-resource-manager/src/ts/react/ResourceBrowser': require('bundle-loader?lazy!pdc-widget-resource-manager/src/ts/react/ResourceBrowser')
});

export class HTMLContainerWidget extends WidgetBase {
    public static _name: string = 'HTML Container';
    public static group = 'Layout';
    public static moduleName: string = 'pdc-widget-html';
    public static icon: string = 'open-file';
    public static themeModule = mainTheme;

    public static load() {
        var def = $.Deferred();

        require.ensure(
            ['./main'],
            (require) => {
                var module: typeof mainModule = require('./main');

                def.resolve(module);
            },
            'pdc-widget-html'
        );

        return def;
    }

    constructor(
        values: { [fieldName: string]: any },
        locked: { [fieldName: string]: any },
        ignoreValidation?: boolean,
        glob: any = {}
    ) {
        values['themeNodeIdToExpand'] = 'pdc-widget-html';
        super(values, locked, ignoreValidation, glob);
    }
}

WidgetBase.register(HTMLContainerWidget);
